import React from 'react';
import classnames from 'classnames';
import { ButtonProps } from './Button.types';
import './Button.scss';
import { Loader } from '../Loader';
import HiddenClip from '../HiddenClip/HiddenClip';

const Button = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  className,
  onClick,
  buttonStyle = 'primary',
  type = 'button',
  value = 'Button',
  showLoader = false,
  positionIconLeft = false,
  forceShowHiddenScreenreaderText,
  ...other
}: ButtonProps) => (
  <button
    type={type}
    className={classnames([
      'tfl-button',
      `tfl-button--${buttonStyle}`,
      { 'tfl-button--disabled': other.disabled },
      {
        'tfl-button--icon-left':
          positionIconLeft && buttonStyle.includes('icon-') && !showLoader,
      },
      {
        'tfl-button--loading': showLoader,
      },
    ])}
    onClick={onClick && ((e) => onClick(e))}
    disabled={showLoader || other.disabled}
    {...other}
  >
    {showLoader && !other.disabled ? <Loader button /> : value}
    {(buttonStyle === 'icon-link-out' || forceShowHiddenScreenreaderText) && (
      <HiddenClip text="Opens in a new tab" />
    )}
  </button>
);

export default Button;
